import { render, staticRenderFns } from "./AddKey.vue?vue&type=template&id=4b4bde98&scoped=true&"
import script from "./AddKey.vue?vue&type=script&lang=js&"
export * from "./AddKey.vue?vue&type=script&lang=js&"
import style0 from "./AddKey.vue?vue&type=style&index=0&id=4b4bde98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4bde98",
  null
  
)

export default component.exports